const LoginInputGroup = ({ field, ...otherProps }) => {
  return (
    <div className="gap-2 p-2 flex flex-col w-full justify-between">
      <label
        className="text-secondary capitalize font-ubuntuBold flex justify-start"
        htmlFor="email"
      >
        {field}
      </label>
      <input
        className={`${
          field === "password" ? "tracking-[0.25em]" : ""
        } text-secondary shadow focus:shadow-primary px-4 py-2 font-ubuntuMedium rounded flex justify-end focus:outline-none`}
        type={field}
        id={field}
        name={field}
        {...otherProps}
      />
    </div>
  );
};

export default LoginInputGroup;
